import * as React from 'react';
import { useContext } from 'react';

import { Button } from '@coursera/cds-core';
import { AddIcon } from '@coursera/cds-icons';

import { ProfileContext } from 'bundles/account-profile/components/recruiting-profile-viewer/ProfileContextProvider';
import ProfileBanner from 'bundles/account-profile/components/recruiting-profile-viewer/components/ProfileBanner';
import TrackedButton from 'bundles/page/components/TrackedButton';

import _t from 'i18n!nls/account-profile';

type Props = {
  handleOpenWorkHistoryModal: () => void;
};

const E2E_SELECTORS = {
  ADD_WORK_EXPERIENCE: 'profile-work-section-add',
} as const;

const EmptyWorkHistory = ({ handleOpenWorkHistoryModal }: Props) => {
  const { restrictHiringSolutions } = useContext(ProfileContext);

  const getBodyText = () => {
    return restrictHiringSolutions
      ? _t('Add your present and/or past work experience here.')
      : _t(
          'Add your past work experience here. If you’re just starting out, you can add internships or volunteer experience instead.'
        );
  };

  return (
    <ProfileBanner
      ctaContent={
        <Button
          variant="secondary"
          iconPosition="before"
          icon={<AddIcon />}
          size="small"
          data-e2e={E2E_SELECTORS.ADD_WORK_EXPERIENCE}
          onClick={handleOpenWorkHistoryModal}
          component={TrackedButton}
          // not tracked in eventing v3
          trackingName="profile_add_work_history_empty"
          requireFullyVisible={false}
          withVisibilityTracking={true}
        >
          {_t('Add work experience')}
        </Button>
      }
      body={getBodyText()}
    />
  );
};

export default EmptyWorkHistory;
